import { cn } from '@/lib/utils';

export function AvatarNotificationBubble() {
  return (
    <div className="absolute -right-1 -top-1 h-3 w-3 rounded-full border-2 border-white bg-accent"></div>
  );
}

export function SideBarNotificationBubble({
  className,
}: {
  className: string;
}) {
  return (
    <div
      className={cn(
        'h-3 w-3 rounded-full border-2 border-white  bg-accent',
        className,
      )}
    ></div>
  );
}
